import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComboInsightsVerticalBorderPositive = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M30.0284 7.42845C30.9242 7.83273 31.5 8.72435 31.5 9.70713V59C31.5 59.8284 30.8284 60.5 30 60.5H4C3.17157 60.5 2.5 59.8284 2.5 59V9.70713C2.5 8.72434 3.07582 7.83273 3.9716 7.42845L16.383 1.82704C16.7753 1.64999 17.2247 1.64999 17.617 1.82704L30.0284 7.42845Z" })
});
export default SvgComboInsightsVerticalBorderPositive;
